<div class="refresh-site" *ngIf="globalErrorHandlerService.reload_app">
  <div class="container-fluid bg-primary" (click)="reload()">
    <i class="fa icon-refresh text-primary"></i>
    <div>
      <h4 class="m0 mb-sm fw-400">Update available</h4>
      <h5 class="m0 fw-400">Click to update <b class="fw-500">WellWink &nbsp;<i class="fa icon-arrow-right fs12 vl-m"></i></b></h5>
    </div>
  </div>
</div>
